if (!customElements.get('t4-marquee')) {
  customElements.define(
    't4-marquee',
    class T4Marquee extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.t4-marquee__toggle');
        if (!this.toggleButton) return;

        this.onToggle = this.onToggle.bind(this);
        this.toggleButton.addEventListener('click', this.onToggle);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.onToggle);
      }

      onToggle() {
        const paused = this.classList.toggle('is-paused');
        this.toggleButton.setAttribute('aria-pressed', paused);
        this.toggleButton.setAttribute(
          'aria-label',
          paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause
        );
      }
    }
  );
}
